import React, { useState, useEffect } from 'react';
import LeftPane from './LeftPane.js';
import RightPane from './RightPane.js';

const portfolioStyle = {
  display: 'grid',
  gridTemplateColumns: '340px 1fr',
  minHeight: '100vh',
  fontFamily: "'Outfit', sans-serif",
  background: 'var(--color-background-primary)',
  color: 'var(--color-text-primary)',
};

const mobileStyle = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  fontFamily: "'Outfit', sans-serif",
  background: 'var(--color-background-primary)',
  color: 'var(--color-text-primary)',
};

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    document.title = 'Brian Huhn Portfolio';
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={isMobile ? mobileStyle : portfolioStyle}>
      <LeftPane />
      <RightPane />
    </div>
  );
};

export default Home;